import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { BlueprintManagementContent } from './Components/BlueprintManagementContent';

export const BlueprintManagement = (): React.JSX.Element => (
  <Page title="Blueprints" accessKey={'blueprints'} isSearchable={true}>
    <BlueprintManagementContent />
  </Page>
);
